import {redirect, useActionData, useLoaderData, useParams, useSubmit} from "react-router-dom";
import ModalUrlWindow from "../../../../components/modalUrl";
import {useForm} from "react-hook-form";
import api from "../../../../hooks/useApi";
import jsonToFormData from "../../../../hooks/jsonToFormData";
import {Autoform} from "../../../../components/forms/autoform";
import {Alert, Box, Typography} from "@mui/material";
import {removeKeys} from "../../../../hooks/reformatPermissions";
import {format, parseISO} from "date-fns";
import {checkIfArrayIsID} from "../../layout";
import {showSnackbar} from "../../../../components/snackbarUtils";
import PageTitle from "../../../../components/PageTitle";

export async function action({request, params}) {
    const formData = await request.formData();
    const searchParams = (new URL(request.url)).searchParams;
    const bookFrom = searchParams.get('book_from');
    const bookTo = searchParams.get('book_to');
    const pricetitle = searchParams.get('pricetitle');
    const rate_id = searchParams.get('rate_id');
    const price_id = searchParams.get('price_id');
    const children_id = searchParams.get('children_id');
    const hotelObjName = searchParams.get('hotel')
        ? 'HotelObj'
        : searchParams.get('hotel_children')
            ? 'HotelObjChildren'
            : null;
    if (!(bookFrom && bookTo && hotelObjName)) {
        return redirect(`/object/${obj_id}/calendar`)
    }
    const obj_id = params.object_id;
    const patch_id = hotelObjName === 'HotelObj' ? searchParams.get('hotel') : searchParams.get('hotel_children');
    const obj = (await api.get(`/api/${hotelObjName}/${patch_id}/`)).data;
    const prices_init = checkIfArrayIsID(obj.price) ? obj.price : obj.price.map(el => el.id);
    try {
        const url = `/api/empty/empty/${children_id}/${rate_id}/${price_id}/`;
        const response = await api.post(url, formData);

        if (response.status === 201) {
            showSnackbar("Ціна успішно додана!", "success", {
                sx: {backgroundColor: "#1de416", color: "white"}
            });

            setTimeout(() => {
                window.location.href = `/object/${obj_id}/calendar`; // Перенаправление через 1 сек
            }, 3000);
        } else {
            showSnackbar('Помилка при додаванні ціни', 'error', {
                sx: {backgroundColor: "#ff0000", color: "white"}
            });
        }
    } catch (e) {
        showSnackbar(`Помилка при додаванні ціни ${e}`, 'error', {
            sx: {backgroundColor: "#ff0000", color: "white"}
        });
        return {error: e}
    }
}

export async function loader({request, params}) {
    const searchParams = (new URL(request.url)).searchParams;
    const object_id = params.object_id;
    const bookFrom = searchParams.get('book_from');
    const bookTo = searchParams.get('book_to');
    // const price = searchParams.get('price');
    // const tax = searchParams.get('tax');
    const rate_id = searchParams.get('rate_id');
    const price_id = searchParams.get('price_id');
    // const another_amount_units = searchParams.get('tax_unit');
    const pricetitle = searchParams.get('pricetitle');
    const hotelObjName = searchParams.get('hotel')
        ? 'hotel'
        : searchParams.get('hotel_children')
            ? 'hotel_children'
            : null;
    if (!(bookFrom && bookTo && hotelObjName)) {
        return redirect(`/object/${object_id}/calendar`)
    }
    let defaultValues = {};
    let form = '';
    if (pricetitle === 'empty') {
        defaultValues = {
            default_period_start: bookFrom,
            default_period_end: bookTo,
            default_hotel_children: searchParams.get(hotelObjName)
        }
        form = (await api.get('/api/CreateObjForms/HotelPrice/')).data.form;
    } else {
        defaultValues = {
            default_period_start: bookFrom,
            default_period_end: bookTo,
            default_hotel_children: searchParams.get(hotelObjName)
        }

        try {
            form = (await api.get(`/api/empty/empty/0/${rate_id}/${price_id}/`)).data.form;
        } catch (e) {
            showSnackbar(`Для змін цін залежних тарифів, необхідно змінювати ціну базового тарифу. ${e}`, 'error', {
                sx: {backgroundColor: "#ff0000", color: "white"}
            });
            return {error: e}
        }
    }
    //defaultValues[hotelObjName] = searchParams.get(hotelObjName);
    //console.log(defaultValues)
    //const form = removeKeys((await api.get('/api/CreateObjForms/HotelPrice/')).data.form, ['period_start', 'period_end']);
    return {form, defaultValues};
}

export default function ObjectCalendarPrice() {
    const loaderData = useLoaderData();
    //console.log(loaderData.defaultValues)
    const actionData = useActionData();
    const {object_id} = useParams()
    const submit = useSubmit()
    const formHook = useForm({defaultValues: {...loaderData.defaultValues}})
    const handleFormSubmit = (data) => {
        const formData = jsonToFormData(data);
        submit(formData, {
            method: 'post'
        })
    }
    return (
        <ModalUrlWindow width='sm' url={`/object/${object_id}/calendar`}
                        title={{text: "Змінити ціну"}}
        >
            <PageTitle title={`Редагування ціни в календарі: ${object_id || "ID"}`} />
            {/*<Box sx={{ mb: 2 }}>*/}
            {/*    <Typography>Період:</Typography>*/}
            {/*    <Typography>{formatISO(loaderData.defaultValues.default_period_start)} - {formatISO(loaderData.defaultValues.default_period_end)}</Typography>*/}
            {/*</Box>*/}
            <Autoform
                formName='HotelPrice'
                fields={loaderData.form}
                formHook={formHook}
                onSubmit={handleFormSubmit}
            />
            {actionData?.error && (
                <Alert severity='error'>
                    {actionData.error.response.data}
                </Alert>
            )}
        </ModalUrlWindow>
    )
}
export const formatISO = (date, date_format = 'dd.MM.yyyy') => {
    return format(parseISO(date), date_format);
}
